import { Alert, Spin, Divider, Row, Col, Card } from 'antd';
import * as React from 'react';
import { resolve } from 'inversify-react';


import { ImageGalleryController } from 'src/app/products/image-gallery/image-gallery.controller'
import { TaxonomyTagsRenderer } from './search-results-taxonomy.view'

import { EntitySchemaDataService } from 'src/app/general/entity-schemas/entity-schema.data';
import { ObjectUtils } from 'src/core/utils/object';
// import { ContextService } from 'src/core/services/context.service';
import { PlaceDataService } from 'src/app/general/places/form/place-form.data';
import { RegionDataService } from 'src/app/general/regions/form/region-form.data';
import { FormatService } from 'src/core/services/format.service';
import { ZuluIcon } from 'src/app/shared/icon';

import { ToastNotifications } from 'src/core/ui/toast';


interface AccommodationSummaryViewProps {
	product?: ProductItem;
	setBusy: (isBusy: boolean) => any;
	left?: boolean;
	textWidth: number;
	picturesWidth: number;
	externalPadding: number;
	internalPadding: number;
	colSpan: number;
}
interface AccommodationSummaryViewState {
	schema: JsonSchema;
	place: string;
	region: string;
}

//esto esta en extended-schema.view.tsx
interface IExtendedProperty {
	name: string;
	label: string;
	model: any;
	onChange: (value: any) => void;
	required: boolean;
	schema: JsonSchema;
}

export class AccommodationSummaryView extends React.Component<AccommodationSummaryViewProps, AccommodationSummaryViewState> {
	@resolve
	formatService: FormatService

	@resolve
	private toast: ToastNotifications;

	constructor(props: AccommodationSummaryViewProps) {
		super(props);

		this.state = {
			schema: null,
			region: null,
			place: null,
		};
	}

	componentDidMount() {
		this.loadSchema().then(() => this.loadData(this.props.product));
	}

	private async loadData(product: ProductItem) {
		const placeDataService = PlaceDataService.make();
		const regionDataService = RegionDataService.make();

		placeDataService.addFilter('id', 'eq', product.placeId);
		placeDataService.addSorting('id', 'asc', true);
		placeDataService.pageSize = 1;

		this.props.setBusy(true);
		try{
			await placeDataService.load(query => query);
		}
		catch(er){
			this.toast.showToast('Error!', ObjectUtils.parseError(er), 'error');
		}
		finally{
			this.props.setBusy(false);
		}
		const place=placeDataService.item.dynamicProperties.displayName.en;

		regionDataService.addFilter('id', 'eq', product.regionId);
		regionDataService.addSorting('id', 'asc', true);
		regionDataService.pageSize = 1;

		this.props.setBusy(true);
		try{
			await regionDataService.load(query => query);
		}
		catch(er){
			this.toast.showToast('Error!', ObjectUtils.parseError(er), 'error');
		}
		finally{
			this.props.setBusy(false);
		}
		const region=regionDataService.item.dynamicProperties.displayName.en;

		this.setState({ place: place, region: region });


	}

	private async loadSchema(): Promise<void> {
		this.props.setBusy(true);

		const entitySchemaService = EntitySchemaDataService.make();

		entitySchemaService.addFilter('name', 'eq', 'Product');
		entitySchemaService.addSorting('name', 'asc', true);
		entitySchemaService.pageSize = 1;

		const entitySchemas = await entitySchemaService.load(query => query);
		const schema = ObjectUtils.toObject<JsonSchema>(entitySchemas[0].schema);
		this.setState({ schema: schema });

		this.props.setBusy(false);

	}


	private isTaxonomy(schema: JsonSchema): boolean {
		return schema.$ref != null || (schema.items != null && schema.items.$ref != null);
	}

	private getExtendedProperties(model: any, schema: JsonSchema): IExtendedProperty[] {
		const { properties, required } = schema.allOf[0];

		return Object.keys(properties)
			.map((propertyName) => {
				const jsc = properties[propertyName] as JsonSchema;
				return {
					name: propertyName,
					label: jsc.title,
					model: model[propertyName],
					onChange: (value: any) => model[propertyName] = value,
					required: required.some((p) => p === propertyName),
					schema: jsc
				};
			});
	}
	private getTaxonomyRef(schema: JsonSchema): string {
		let taxonomy: string;
		if (schema.$ref != null) {
			taxonomy = schema.$ref;
		} else {
			taxonomy = schema.items.$ref;
		}

		return taxonomy;
	}

	render() {
		const { product, setBusy, left, picturesWidth, textWidth, externalPadding, internalPadding, colSpan } = this.props;
		const { schema, region, place } = this.state;

		if (product && schema && region && place) {
			const validTaxonomies = product.category.taxonomicFields;
			const model = product.dynamicProperties;

			let properties = this.getExtendedProperties(model, schema);
			if (validTaxonomies != null) {
				properties = properties.filter(m => this.isTaxonomy(m.schema) && validTaxonomies.some(p => p === m.name));
			}

			const taxonomiesRefs = properties.map((m) => [this.getTaxonomyRef(m.schema), m.name]);
			const taxonomiesViews = taxonomiesRefs.map((taxonomy) => {
				const taxName=taxonomy[0];
				const propName=taxonomy[1];
				return <TaxonomyTagsRenderer key={taxName} model={model} propName={propName} taxonomyDefinitionName={taxName} colSpan={colSpan} setBusy={setBusy} />
			});

			if (product == null) {
				return (
					<Spin spinning={true} size="large">
						<Alert
							message="LOADING"
							description="Please wait to loading product info."
							type="info"
						/>
					</Spin>
				);
			}
			const pictures =
				<Col offset={left ? 1 : 0} key={0}>
					<div style={{ width: picturesWidth }}>
						<ImageGalleryController
							mode={"display"}
							model={product.documentsLibraryId}
							setBusy={setBusy}
							hideEdit={true}
						/>
					</div>
				</Col>;
			const text =
				<Col offset={left ? 0 : 1} key={1}>
					<div style={{ width: textWidth }}>
						<p>{product.dynamicProperties.translations.en}</p>
					</div>
				</Col>
			let both;
			if (left) {
				both = [text, pictures];
			}
			else {
				both = [pictures, text]
			}

			return (
				<div style={{ padding: externalPadding }}>
					<Card>
						<Row style={{ padding: internalPadding }} type="flex" justify="start">
							{...both}
						</Row>
						<Row style={{ padding: internalPadding }} >
							<div>
								<Row type="flex" justify="start">
									<Col span={colSpan}>
										<span style={{ fontWeight: "bold" }}>Category:</span>
									</Col>
									<Col>
										{product.category.displayName}
									</Col>
								</Row>
								<Divider />

								<Row type="flex" justify="start">
									<Col span={colSpan}>
										<span style={{ fontWeight: "bold" }}>Region:</span>
									</Col>
									<Col>
										{this.state.region}
									</Col>
								</Row>
								<Divider />

								<Row type="flex" justify="start">
									<Col span={colSpan}>
										<span style={{ fontWeight: "bold" }}>Place:</span>
									</Col>
									<Col>
										{this.state.place}
									</Col>
								</Row>
								<Divider />

								<Row type="flex" justify="start">
									<Col span={colSpan}>
										<span style={{ fontWeight: "bold" }}>Check-In:</span>
									</Col>
									<Col span={8}>
										<ZuluIcon style={{ fontSize: 24 }} type="calendar" /> Check-in from {this.formatService.toString('small-time', new Date(product.dynamicProperties.accomodation.checkIn), 'utc')}
									</Col>
									<Col span={8}>
										<ZuluIcon style={{ fontSize: 24 }} type="calendar" /> Check-out before {this.formatService.toString('small-time', new Date(product.dynamicProperties.accomodation.checkOut), 'utc')}
									</Col>
								</Row>
								<Divider />
								{...taxonomiesViews}
							</div>
						</Row>
					</Card>
				</div>
			);
		}
		else {
			return null;
		}
	}
}




// WEBPACK FOOTER //
// ./src/app/bookings/search/results/search-results-accommodation-summary.view.tsx